<template>
  <div id="app">
    <NavBars></NavBars>
    <!-- <keep-alive> -->
    <router-view :key="$route.fullPath" />
    <!-- </keep-alive> -->
    <TheFooterComponent></TheFooterComponent>
  </div>
</template>
<script>
import NavBars from "./components/NavBars.vue";
import TheFooterComponent from "./components/footer.vue";

export default {
  name: "HomeView",
  data() {
    return {};
  },
  components: {
    NavBars,
    TheFooterComponent, // 推荐使用 kebab-case
  },
  computed: {},
  mounted() {
    // this.$nextTick(() => {
    //   const paddingValue =
    //     this.$route.path === "/" ? "0.70833rem" : "1.1875rem";
    //   document.body.style.setProperty("padding-top", paddingValue, "important");
    // });
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
  min-height: calc(100vh - 50px);
  position: relative;
  -webkit-text-size-adjust: 100% !important;
}
body {
  padding: 0;
  margin: 0;
}
* {
  box-sizing: border-box;
  -webkit-text-size-adjust: 100% !important;
  -ms-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
}
</style>
